export default __webpack_public_path__ + "lightMap.png";